import React from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { FileResponse } from "../Requests/portfolioRequests";
import { toast } from "react-toastify";
import AboveTooltip from "./AboveTooltip";
import Loading from "./Loading/Loading";

interface IProps {
  getFile: () => Promise<FileResponse>;
  text?: React.ReactNode;
  /** Menu-item label when variant is "menu". Defaults to "Excel". */
  label?: string;
  /**
   * button: icon-only tool button (like chart PNG download)
   * menu: plain text+icon for ExpandableButton dropdown items
   */
  variant?: "button" | "menu";
  className?: string;
  /** Hover tooltip. Defaults to «دانلود فایل». */
  title?: string;
}

const FileDownloader = ({
  getFile,
  text,
  label = "Excel",
  variant = "button",
  className,
  title = "دانلود فایل",
}: IProps) => {
  const fileRef = React.useRef<HTMLAnchorElement>(null);
  const [loading, setLoading] = React.useState(false);

  const getLink = (fileResponse: FileResponse) => {
    if (!fileRef.current) return;

    const blobUrl = URL.createObjectURL(fileResponse.blob);
    const link = fileRef.current;
    link.href = blobUrl;
    link.setAttribute("download", fileResponse.filename);
    link.target = "_blank";
    link.click();
    URL.revokeObjectURL(blobUrl);
  };

  const getExcelFileHandler = (e?: React.MouseEvent<HTMLElement>) => {
    e?.stopPropagation();
    if (loading) return;
    setLoading(true);
    getFile()
      .then((res) => getLink(res))
      .catch(() => toast.error("خطا در دریافت فایل"))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <a href="" className="hidden" ref={fileRef} />
      {text !== undefined ? (
        <div onClick={getExcelFileHandler} aria-busy={loading}>
          {loading ? <Loading className="!text-sky-600" size={16} /> : text}
        </div>
      ) : variant === "menu" ? (
        <div
          onClick={getExcelFileHandler}
          className={`inline-flex items-center gap-1.5 cursor-pointer whitespace-nowrap font-normal text-sm ${
            className || ""
          }`}
        >
          {loading ? (
            <Loading className="!text-sky-600" size={16} />
          ) : (
            <>
              <FileDownloadOutlinedIcon fontSize="small" />
              <span>{label}</span>
            </>
          )}
        </div>
      ) : (
        <AboveTooltip title={title}>
          <button
            type="button"
            className={`chart-tool-btn ${className || ""}`}
            aria-label={title}
            disabled={loading}
            onClick={getExcelFileHandler}
          >
            {loading ? (
              <Loading className="!text-sky-600" size={16} />
            ) : (
              <FileDownloadOutlinedIcon fontSize="small" />
            )}
          </button>
        </AboveTooltip>
      )}
    </>
  );
};

export default FileDownloader;
